import { render } from "./Action.vue?vue&type=template&id=375f270d&scoped=true&ts=true"
import script from "./Action.vue?vue&type=script&lang=ts"
export * from "./Action.vue?vue&type=script&lang=ts"

import "./Action.vue?vue&type=style&index=0&id=375f270d&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375f270d"]])

export default __exports__